import { createFileRoute } from "@tanstack/react-router";
import HusselochtendOrganiseren from "@/pages/HusselochtendOrganiseren";

export const Route = createFileRoute("/husselochtend-organiseren")({
  head: () => ({
    meta: [
      { title: "Husselochtend organiseren — gezellig ochtend-tennis | De Hussel App" },
      { name: "description", content: "Husselochtend op je tennisclub organiseren? Automatische indelingen, push-meldingen en geen vrijwilligers nodig. Ideaal voor senioren, ouders en thuiswerkers." },
      { property: "og:title", content: "Husselochtend organiseren — gezellig ochtend-tennis | De Hussel App" },
      { property: "og:description", content: "Husselochtend op je tennisclub organiseren? Automatische indelingen, push-meldingen en geen vrijwilligers nodig. Ideaal voor senioren, ouders en thuiswerkers." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://dehusselapp.nl/husselochtend-organiseren" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://dehusselapp.nl/husselochtend-organiseren" }],
  }),
  component: HusselochtendOrganiseren,
});
